import PropTypes from 'prop-types';
import React from 'react';
import { sanitizeContent } from '../utils/helper';

import '../global-sass/main.scss';

const renderSpecDescription = (specIds, specObj) =>
	specIds.map(id => {
		let detailColon = '';
		let specIdSpanClass;
		let detailSpan;

		if (specObj[id].detail) {
			detailColon = ': ';
			specIdSpanClass = 'text-muted';
			detailSpan = <span>{specObj[id].detail}</span>;
		}

		const html = sanitizeContent(
			`${specObj[id].description}${detailColon}`
		);

		/* eslint react/no-danger: 0 */
		return (
			<li key={id}>
				<span
					className={specIdSpanClass}
					dangerouslySetInnerHTML={{ __html: html }}
				/>
				{detailSpan}
			</li>
		);
	});

export default class SpecDescription extends React.Component {
	render() {
		const { specIds, specification } = this.props;
		const specObj = specification.reduce((obj, itm) => {
			return {
				...obj,
				[itm.id]: itm.spec
			};
		}, {});

		return (
			<ul className="list-unstyled list-spaced line-height-condensed mt-4 ml-2 pl-5">
				{renderSpecDescription(specIds, specObj)}
			</ul>
		);
	}
}

SpecDescription.propTypes = {
	specIds: PropTypes.arrayOf(PropTypes.number).isRequired,
	specification: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.number.isRequired,
			spec: PropTypes.object.isRequired
		})
	).isRequired
};



// WEBPACK FOOTER //
// ./src/components/SpecDescription.jsx